import {
  GET_ANNOUNCEMENT,
  GET_ANNOUNCEMENT_SUCCESS,
  GET_ANNOUNCEMENT_FAILURE,
  UPDATE_ANNOUNCEMENT_STATUS,
  UPDATE_ANNOUNCEMENT_STATUS_SUCCESS,
  UPDATE_ANNOUNCEMENT_STATUS_FAILURE,
  DELETE_ANNOUNCEMENT,
  DELETE_ANNOUNCEMENT_SUCCESS,
  DELETE_ANNOUNCEMENT_FAILURE,
  EDIT_ANNOUNCEMENT,
  EDIT_ANNOUNCEMENT_SUCCESS,
  EDIT_ANNOUNCEMENT_FAILURE,
  ADD_ANNOUNCEMENT,
  ADD_ANNOUNCEMENT_SUCCESS,
  ADD_ANNOUNCEMENT_FAILURE,
} from "../Constants";

const init = {
  data: {},
  delete_data: {},
  edit_data: {},
  add_data: {},
  update_data: {},
};

const AnnouncementReducer = (state = init, action) => {
  switch (action.type) {
    case GET_ANNOUNCEMENT:
      return { ...state, loading: true };
    case GET_ANNOUNCEMENT_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case GET_ANNOUNCEMENT_FAILURE:
      return { ...state, loading: false, data: action.payload };
    case UPDATE_ANNOUNCEMENT_STATUS:
      return { ...state, loading: true };
    case UPDATE_ANNOUNCEMENT_STATUS_SUCCESS:
      return { ...state, loading: false, update_data: action.payload };
    case UPDATE_ANNOUNCEMENT_STATUS_FAILURE:
      return { ...state, loading: false, update_data: action.payload };
    case DELETE_ANNOUNCEMENT:
      return { ...state, loading: true };
    case DELETE_ANNOUNCEMENT_SUCCESS:
      return { ...state, loading: false, delete_data: action.payload };
    case DELETE_ANNOUNCEMENT_FAILURE:
      return { ...state, loading: false, delete_data: action.payload };
    case EDIT_ANNOUNCEMENT:
      return { ...state, loading: true };
    case EDIT_ANNOUNCEMENT_SUCCESS:
      return { ...state, loading: false, edit_data: action.payload };
    case EDIT_ANNOUNCEMENT_FAILURE:
      return { ...state, loading: false, edit_data: action.payload };
    case ADD_ANNOUNCEMENT:
      return { ...state, loading: true };
    case ADD_ANNOUNCEMENT_SUCCESS:
      return { ...state, loading: false, add_data: action.payload };
    case ADD_ANNOUNCEMENT_FAILURE:
      return { ...state, loading: false, add_data: action.payload };
    default:
      return state;
  }
};

export default AnnouncementReducer;
